export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16">基於實現在使用者身份認證、手機設備安全、接收資訊推送、登入第三方服務、通過第三方平臺分享資訊以及保障交易安全的需要，在向您提供服務過程中，盈寶證券會與第三方分享資訊，我們將這些第三方服務商的名稱、使用目的、官網連結分別列明如下。</div>

    <div class="doc-main-title">一、分享類</div>

    <div class="doc-text">1. 微信開放平臺</div>
    <div class="doc-text">來源：深圳市騰訊計算機系統有限公司</div>
    <div class="doc-text">使用目的：幫助用戶使用微信分享功能</div>
    <div class="doc-text">官網連結：https://open.weixin.qq.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</div>

    <div class="doc-text">2. 新浪微博開放平臺</div>
    <div class="doc-text">來源：北京微夢創科網絡技術有限公司</div>
    <div class="doc-text">使用目的：幫助用戶使用微博分享功能</div>
    <div class="doc-text">官網連結：https://open.weibo.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://weibo.com/signup/v5/privacy?spm=a1zaa.8161610.0.0.4f8776217Wu8R1</div>

    <div class="doc-text">3. QQ互联</div>
    <div class="doc-text">來源：深圳市騰訊計算機系統有限公司</div>
    <div class="doc-text">使用目的：幫助用戶使用QQ帳號的分享功能</div>
    <div class="doc-text">官網連結：https://open.tencent.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://wiki.connect.qq.com/QQ互联SDK隐私保护声明</div>

    <div class="doc-text">4. Facebook分享</div>
    <div class="doc-text">來源：Facebook</div>
    <div class="doc-text">使用目的：幫助用戶使用Facebook的分享功能</div>
    <div class="doc-text">官網連結：https://developers.facebook.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://www.facebook.com/privacy/explanation</div>

    <div class="doc-text">5. TwitterKit</div>
    <div class="doc-text">來源：Twitter</div>
    <div class="doc-text">使用目的：幫助用戶使用Twitter的分享功能</div>
    <div class="doc-text">官網連結：https://github.com/twitter-archive/twitter-kit-ios</div>
    <div class="doc-text doc-pb28">隱私政策連結：無</div>

    <div class="doc-text">6. shareSDK</div>
    <div class="doc-text">來源：上海遊昆資訊技術有限公司</div>
    <div class="doc-text">使用目的：幫助用戶使有各社交平臺分享功能</div>
    <div class="doc-text">官網連結：https://www.mob.com</div>
    <div class="doc-text">隱私政策連結：https://www.mob.com/about/policy</div>

    <div class="doc-main-title">二、推送類</div>

     <div class="doc-text">1. Google推送</div>
    <div class="doc-text">来源：Google</div>
    <div class="doc-text">使用目的：向使用支持google服务设备的用户进行消息推送</div>
    <div class="doc-text">官網連結：https://firebase.google.com/docs/cloud-messaging</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://firebase.google.com/support/privacy?hl=zh-cn</div>

    <div class="doc-text">2. 極光推送</div>
    <div class="doc-text">來源：深圳市和訊華穀信息技術有限公司</div>
    <div class="doc-text">使用目的：向使用者發送離線消息推送</div>
    <div class="doc-text">官網連結：https://www.jiguang.cn</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://www.jiguang.cn/license/privacy</div>

    <div class="doc-text">3. 小米推送</div>
    <div class="doc-text">來源：小米科技有限責任公司</div>
    <div class="doc-text">使用目的：向使用者發送離線消息推送</div>
    <div class="doc-text">官網連結：https://dev.mi.com/platform</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://dev.mi.com/console/doc/detail?pId=1822</div>

    <div class="doc-text">4. 華為推送</div>
    <div class="doc-text">來源：華為科技有限公司</div>
    <div class="doc-text">使用目的：向使用者發送離線消息推送</div>
    <div class="doc-text">官網連結：https://developer.huawei.com/consumer/cn/appgallery/</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://developer.huawei.com/consumer/cn/doc/app/20213#h1-1636428705592-2</div>

    <div class="doc-text">5. 榮耀推送</div>
    <div class="doc-text">來源：榮耀終端有限責任公司</div>
    <div class="doc-text">使用目的：向使用者發送離線消息推送</div>
    <div class="doc-text">官網連結：https://developer.hihonor.com/cn</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://www.hihonor.com/cn/privacy/privacy-policy/</div>

    <div class="doc-text">6. OPPO推送</div>
    <div class="doc-text">來源：廣東歐珀移動通信有限公司</div>
    <div class="doc-text">使用目的：向使用者發送離線消息推送</div>
    <div class="doc-text">官網連結：https://open.oppomobile.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://open.oppomobile.com/new/developmentDoc/info?id=11139</div>

    <div class="doc-text">7. 魅族推送</div>
    <div class="doc-text">來源：珠海市魅族科技有限公司</div>
    <div class="doc-text">使用目的：向使用者發送離線消息推送</div>
    <div class="doc-text">官網連結：http://open.flyme.cn/</div>
    <div class="doc-text">隱私政策連結：https://open.flyme.cn/docs?id=202</div>

    <div class="doc-main-title">三、支付類</div>

    <div class="doc-text">1. Google Pay</div>
    <div class="doc-text">來源：Google</div>
    <div class="doc-text">使用目的：為使用者提供Google Pay支付服務</div>
    <div class="doc-text">官網連結：https://developers.google.com/identity/sign-in/android/</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://policies.google.com/privacy</div>

    <div class="doc-text">2. Apple pay</div>
    <div class="doc-text">來源：Apple</div>
    <div class="doc-text">使用目的：為使用者提供Apple Pay支付服務</div>
    <div class="doc-text">官網連結：https://www.apple.com</div>
    <div class="doc-text">隱私政策連結：https://www.apple.com/legal/privacy/en-ww/</div>

    <div class="doc-main-title">四、其他類</div>

    <div class="doc-text">1. IM SDK</div>
    <div class="doc-text">來源：北京易掌雲峰科技有限公司</div>
    <div class="doc-text">使用目的：為用戶提供即時通信功能</div>
    <div class="doc-text">官網連結：https://www.easemob.com/</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://www.easemob.com/protocol</div>

    <div class="doc-text">2. Bugly</div>
    <div class="doc-text">來源：深圳市騰訊計算機系統有限公司</div>
    <div class="doc-text">使用目的：幫助開發人員定位用戶使用App過程中的閃退問題</div>
    <div class="doc-text">官網連結：https://bugly.qq.com/</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf</div>

    <div class="doc-text">3. 阿裡雲OSS、文本內容審查、MSM</div>
    <div class="doc-text">來源：阿裡雲計算有限公司</div>
    <div class="doc-text">使用目的：對使用者頭像及回饋圖片儲存、敏感內容審查、發送短信的服務</div>
    <div class="doc-text">官網連結：https://www.aliyun.com/</div>
    <div class="doc-text doc-pb28">隱私政策連結：http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.19720258.J_9220772140.87.e9392c4a3upEEK</div>

    <div class="doc-text">4. 騰訊OCR</div>
    <div class="doc-text">來源：騰訊雲計算（北京）有限責任公司</div>
    <div class="doc-text">使用目的：為使用者提供身份資訊識別服務</div>
    <div class="doc-text">官網連結：https://cloud.tencent.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://cloud.tencent.com/document/product/301/11470</div>

    <div class="doc-text">5. 友盟+</div>
    <div class="doc-text">來源：北京銳訊靈通科技有限公司、友盟同欣（北京）科技有限公司</div>
    <div class="doc-text">使用目的：統計分析及應用性能監測</div>
    <div class="doc-text">官網連結：https://www.umeng.com</div>
    <div class="doc-text doc-pb28">隱私政策連結：https://www.umeng.com/page/policy</div>
  </div>
`
